const config = {
  host: "https://api.i-iptv.com",
};

export default config;
